import React, { useMemo, useRef, useState, useCallback } from 'react';
import c from 'classnames';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import AddIcon from '@wix/da-ds/pkg/Icons/24x24/Add';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { BiData } from '@wix/da-bi/pkg/events';
import ListMenu from '../../../_partials/LegacyListMenu';
import { mobileSubmitMenuItems, mobileSubmitMenuItemsNew } from '../../../constants';
import SubmitMenuItem from './SubmitMenuItem';
import { useOnOutsideClick } from '@wix/da-hooks/pkg/useOnOutsideClick';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import s from './SubmitDropdown.scss';
const SubmitDropdown = ({ className, menuClassName })=>{
    const isEditorMobile = useFlag('editor_mobile');
    const rootRef = useRef(null);
    const [isOpen, setOpen] = useState(false);
    const closeMenu = useCallback(()=>setOpen(false), []);
    useOnOutsideClick(rootRef, closeMenu);
    const submitMenuItems = useMemo(()=>{
        if (isEditorMobile) {
            return mobileSubmitMenuItemsNew.map(({ type, label, target, verificationAction = 'submit', link, modalType, modalOptions })=>{
                return {
                    key: label,
                    renderElement: ()=>/*#__PURE__*/ React.createElement(SubmitMenuItem, {
                            className: s['submit-menu-item'],
                            type: type,
                            modalType: modalType,
                            modalOptions: modalOptions,
                            label: label,
                            link: link,
                            target: target,
                            verificationAction: verificationAction
                        })
                };
            });
        }
        return mobileSubmitMenuItems.map(({ type, label, target, verificationAction = 'submit', link, modalType, modalOptions })=>{
            return {
                key: label,
                renderElement: ()=>/*#__PURE__*/ React.createElement(SubmitMenuItem, {
                        className: s['submit-menu-item'],
                        type: type,
                        modalType: modalType,
                        modalOptions: modalOptions,
                        label: label,
                        link: link,
                        target: target,
                        verificationAction: verificationAction
                    })
            };
        });
    }, [
        isEditorMobile
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className),
        ref: rootRef
    }, /*#__PURE__*/ React.createElement(BrandedButton, {
        variant: "brand-green",
        size: "medium",
        className: s['button'],
        onClick: ()=>setOpen((open)=>!open),
        biData: isOpen ? undefined : BiData({
            evid: 703,
            sectionname: 'dropdown'
        })
    }, /*#__PURE__*/ React.createElement(AddIcon, {
        className: s['icon'],
        size: IconSize.MEDIUM,
        disableDefaultColors: true
    })), isOpen && /*#__PURE__*/ React.createElement(ListMenu, {
        className: c('ds-surface-tertiary', s['menu'], menuClassName),
        items: submitMenuItems
    }));
};
SubmitDropdown.displayName = 'SubmitDropdown';
export default SubmitDropdown;

//# sourceMappingURL=SubmitDropdown.js.map